import {ApiContext} from '@vf/utility/ApiContextProvider/ApiContextProvider';
import React, {useContext, useEffect, useReducer} from 'react';
import config from './config';
import HoursManagementContext from './ManagementContext';
import {IMessage} from './ManagementContextPropTypes';
import {reducer} from './reducer';
import {actions} from './reducer';
export const INITIAL_STATE = {
  ...config,
};
export enum ENTITY_TYPES {
  FLOWS = 'flows',
  CUSTOMER_QUEUE_FLOWS = 'customerQueueFlows',
  QUEUES = 'queues',
  PROMPTS = 'prompts',
  NUMBERS = 'numbers',
}
const HoursManagementContextProvider: React.FC<React.ReactNode> = ({
  children,
}) => {
  const api = useContext(ApiContext);
  const [state, dispatch] = useReducer(reducer, INITIAL_STATE);

  useEffect(() => {
    listClosures();
    listClosurePrompts();
    getQueues();
    getNumbers();
    getTimezones();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [api]);

  const getQueueMetadata = (queueId: string) => {
    const queue = state.queues.find((queue) => queue.Id === queueId);
    return queue;
  };
  const getEntityAttrValue = (
    type: ENTITY_TYPES,
    keyType: string,
    keyValue: string,
    returnAttr: string = null,
  ): any => {
    const item = state[type].find((o) => o[keyType] === keyValue);
    if (!item) return '';
    return returnAttr ? item[returnAttr] : item;
  };

  const listClosures = async () => {
    dispatch({type: actions.LOADING_CLOSURES, payload: true});
    try {
      const closuresList = await api.closure.getAllClosures();
      dispatch({type: actions.LIST, payload: {closuresList}});
    } catch (err) {
      dispatch({type: actions.LOADING_CLOSURES, payload: false});
      dispatch({
        type: actions.SET_ERROR,
        payload: {error: 'Server error while loading closures data'},
      });
    }
  };

  const getQueues = async () => {
    try {
      const queues = await api.helpers.getAllQueues();
      dispatch({
        type: actions.GET_QUEUES,
        payload: {
          queues,
        },
      });
    } catch (err) {
      console.warn('Unable to load queues', err);
    }
  };
  const getNumbers = async () => {
    try {
      const numbers = await api.helpers.getAllNumbers();
      dispatch({
        type: actions.GET_NUMBERS,
        payload: {
          numbers,
        },
      });
    } catch (err) {
      console.warn('Unable to load claimed numbers', err);
    }
  };
  const getTimezones = async () => {
    try {
      const timezones = await api.helpers.getAllTimezones();
      dispatch({
        type: actions.GET_TIMEZONES,
        payload: {
          timezones,
        },
      });
    } catch (err) {
      console.warn('Unable to load timezones', err);
    }
  };
  const listClosurePrompts = async () => {
    dispatch({type: actions.LOADING_PROMPTS, payload: true});
    try {
      const prompts = await api.closure.getClosurePrompts();
      dispatch({
        type: actions.LIST_PROMPTS,
        payload: {prompts: prompts.prompts},
      });
    } catch (err) {
      dispatch({type: actions.LOADING_PROMPTS, payload: false});
      setMsg({
        message: 'Server error while loading prompts data',
        type: 'error',
      });
    }
  };

  const setMsg = (msg: IMessage) => {
    dispatch({type: actions.SET_MESSAGE, payload: {msg}});
  };

  return (
    <HoursManagementContext.Provider
      value={{
        ...state,
        getQueueMetadata,
        setMsg,
        getEntityAttrValue,
        listClosures,
        listClosurePrompts,
      }}>
      {children}
    </HoursManagementContext.Provider>
  );
};

export default HoursManagementContextProvider;
